import { render, staticRenderFns } from "./searchPopBD.vue?vue&type=template&id=7baa1b16&scoped=true&"
import script from "./searchPopBD.vue?vue&type=script&lang=ts&"
export * from "./searchPopBD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baa1b16",
  null
  
)

export default component.exports